(function () {
  'use strict';

  if (window.PGReactionVideosV56) return;
  window.PGReactionVideosV56 = true;

  var media = [
    {
      video: 'https://cdn.shopify.com/videos/c/vp/440861789c4f4fe8a7364af027581440/440861789c4f4fe8a7364af027581440.HD-720p-1.6Mbps-11766663.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-reaction-cover-1.webp?v=1788468413'
    },
    {
      video: 'https://cdn.shopify.com/videos/c/vp/af5ddff0ca9e4ea6b42a58ed84a63b4c/af5ddff0ca9e4ea6b42a58ed84a63b4c.HD-720p-1.6Mbps-90534633.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-reaction-cover-2.webp?v=1788468399'
    },
    {
      video: 'https://cdn.shopify.com/videos/c/vp/5993768e27174869b138830fd8c4f2fd/5993768e27174869b138830fd8c4f2fd.HD-720p-1.6Mbps-90534631.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-reaction-cover-3_93f153b4-418a-49c3-92fe-e376a42ff0a8.webp?v=1788468385'
    },
    {
      video: 'https://cdn.shopify.com/videos/c/vp/aff4793736dd4a9ea7a2228e1790248b/aff4793736dd4a9ea7a2228e1790248b.HD-720p-1.6Mbps-90534632.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-reaction-cover-4.webp?v=1788468362'
    }
  ];

  function initCard(card, index) {
    if (!card || card.dataset.pgReactionV56 === 'true') return;

    var video = card.querySelector('video');
    var source = video && video.querySelector('source');
    var item = media[index];
    if (!video || !item) return;

    card.dataset.pgReactionV56 = 'true';
    card.classList.add('pg-reaction-v56-ready');

    if (!video.getAttribute('poster') && item.poster) video.setAttribute('poster', item.poster);
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'metadata');

    if (source && source.src !== item.video) {
      source.src = item.video;
      source.type = 'video/mp4';
      video.load();
    }

    var play = document.createElement('button');
    play.type = 'button';
    play.className = 'pg-reaction-play-v56';
    play.setAttribute('aria-label', 'Play customer reaction video');
    play.innerHTML = '<span aria-hidden="true">&#9654;</span>';
    card.appendChild(play);

    function playing(isPlaying) {
      card.classList.toggle('pg-reaction-v56-playing', isPlaying);
      play.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
    }

    play.addEventListener('click', function () {
      var result = video.play();
      if (result && typeof result.catch === 'function') result.catch(function () {});
    });

    video.addEventListener('play', function () { playing(true); });
    video.addEventListener('pause', function () { playing(false); });
    video.addEventListener('ended', function () { playing(false); });
  }

  function apply() {
    var section = document.getElementById('pg-home-reactions');
    if (!section) return;

    var cards = section.querySelectorAll('.pg-reactions__card');
    Array.prototype.forEach.call(cards, function (card, index) {
      if (index < media.length) initCard(card, index);
    });
  }

  function boot() {
    apply();
    [120, 500, 1200].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('pageshow', apply, { passive: true });
})();
